import { useContracts } from "@/hooks/contracts";
import { resolveUnitOfBilling } from "@/utils/billingModel";
import { transformPricingTiers } from "@/utils/pricing";
const toUsagePlan = (contractDetails, apiKeysLimitOverride)=>{
    if (!contractDetails) {
        return null;
    }
    const { contract, usagePlan, pricingPolicy } = contractDetails;
    const unitOfMeasure = contract?.pricing_terms?.unit_of_measure || "bytes";
    const tieredPricing = transformPricingTiers({
        contractTiers: contract?.pricing_terms?.tiers,
        pricingPolicyTiers: pricingPolicy?.Tiers,
        unitOfMeasure
    });
    const marketplaceQuota = contract?.pricing_terms?.aws_marketplace ? {
        includedQuotaValue: contract.pricing_terms.aws_marketplace.included_quota_value,
        includedQuotaUnit: contract.pricing_terms.aws_marketplace.included_quota_unit,
        consumptionUnit: contract.pricing_terms.aws_marketplace.consumption_unit
    } : undefined;
    return {
        name: usagePlan?.Name || usagePlan?.UsagePlanId || "Unknown Plan",
        product: contract?.ProductCode || "Unknown Product",
        tieredPricing,
        unitOfBilling: resolveUnitOfBilling(pricingPolicy, contract?.pricing_terms),
        unitOfMeasure,
        currency: contract?.pricing_terms?.currency || pricingPolicy?.Currency || "USD",
        apiKeysLimit: apiKeysLimitOverride ?? contract?.ApiKeysLimit ?? usagePlan?.ApiKeysLimit ?? 15,
        rateLimit: usagePlan?.RateLimit || 10,
        burstLimit: usagePlan?.BurstLimit || 0,
        contractQuota: usagePlan?.QuotaValue || 100000,
        quotaUnit: usagePlan?.QuotaUnits || "KB",
        marketplaceQuota
    };
};
export const useUsagePlan = ({ contractId, enabled = true })=>{
    const { data: contractsData, isLoading: isLoadingContracts } = useContracts(undefined, enabled);
    const contractDetails = contractsData?.contracts.find(({ contract })=>contract.ContractId === contractId);
    return {
        usagePlan: toUsagePlan(contractDetails),
        isLoadingContracts
    };
};
export default useUsagePlan;
